import { RefObject, useEffect, useRef } from 'react';

export function useInViewOnce(ref: RefObject<Element>, onView: () => void): void {
	const fired = useRef(false);
	useEffect(() => {
		const el = ref.current;
		if (!el || fired.current || typeof IntersectionObserver === 'undefined') {
			return;
		}
		const obs = new IntersectionObserver(entries => {
			for (const e of entries) {
				if (e.isIntersecting && !fired.current) {
					fired.current = true;
					onView();
					obs.disconnect();
				}
			}
		});
		obs.observe(el);
		return () => obs.disconnect();
	}, [ref, onView]);
}
